import React, {Component, Fragment} from "react";
import * as R from "ramda";
import SimpleInput from "../../../../modules/SimpleInput";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleDate from "../../../../modules/SimpleDate";
import M from "moment";
import SimpleCheckBox from "../../../../modules/SimpleCheckBox";
import Api from "../../../../Services/Api";
import {mapToDDL} from "../../../common/mapper";
import FlexView from "react-flexview";

class MasterPackageHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isAllSelected: false,
            isSpecificSelected: false,
            dataCabang: [],
            dataVariant: [],
        };
    }

    componentDidMount() {
        this.fetchDataCabang();
        this.fetchDataVariant();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (
            prevProps.controls.packageAllCabang.value !== this.props.controls.packageAllCabang.value ||
            prevProps.controls.packageSpecificCabang.value !== this.props.controls.packageSpecificCabang.value
        ) {
            this.setState((prevState) => ({
                ...prevState,
                isAllSelected: this.props.controls.packageAllCabang.value,
                isSpecificSelected: this.props.controls.packageSpecificCabang.value,
            }))
        }
    }

    handleSelectedBranch = (e, type) => {
        const isChecked = e.target.checked;

        if (type === "all") {
            this.setState((prevValue) => ({
                ...prevValue,
                isAllSelected: isChecked,
                isSpecificSelected: false,
            }));
            this.props.setValue("listCabang", []);
            this.props.setValue("packageAllCabang", isChecked);
            this.props.setValue("packageSpecificCabang", false);
        }

        if (type === "specific") {
            this.setState((prevValue) => ({
                ...prevValue,
                isSpecificSelected: isChecked,
                isAllSelected: false,
            }));
            this.props.setValue("packageSpecificCabang", isChecked);
            this.props.setValue("packageAllCabang", false);
        }
    }

    fetchDataCabang = async () => {
        try {
            let res = await Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang();
            if (res.ok) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    dataCabang: res.data.data,
                }));
            }
        } catch (error) {
            console.log("errors: ", error);
        }
    }

    fetchDataVariant = async () => {
        try {
            let res = await Api.create("NAGAMAS_MASTER_DATA").getAllVariant();
            if (res.ok) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    dataVariant: res.data.data,
                }));
            }
        } catch (error) {
            console.log("errors: ", error);
        }
    }

    handleHasPeriod = (value) => {
        this.props.setValue("packageHasGracePeriod", value);
        if (value) {
            this.props.setValue("packageStartDate", null);
            this.props.setValue("packageEndDate", null);
            this.props.setValue("packageGracePeriod", null);
        }
    };

    render() {
        return (
            <Fragment>
                <div className="grid grid-2x gap-20px grid-mobile-none">
                    <div id="grid-1">
                        <SimpleInput
                            id="input_text_packageID"
                            name="packageId"
                            label="Paket ID"
                            mandatory
                            readOnly
                            errorMessage={this.props.errors.packageId}
                            value={this.props.controls.packageId.value}
                            onChange={({target}) =>
                                this.props.setValue(target.name, target.value)
                            }
                        />
                        <SimpleInput
                            id="select_options_packageName"
                            name="packageName"
                            label="Nama Paket"
                            mandatory
                            errorMessage={this.props.errors.packageName}
                            value={this.props.controls.packageName.value}
                            onChange={({target}) =>
                                this.props.setValue(target.name, target.value)
                            }
                        />
                        <div className="margin-bottom-30px">
                            <div className="margin-5px">
                                <div className="txt-site txt-11 txt-main txt-bold">
                                    <h4>Cabang Berlaku<span style={{color: "red"}}>*</span></h4>
                                </div>
                            </div>
                            <div className="grid grid-2x grid-mobile-none gap-15px">
                                <SimpleCheckBox
                                    id="packageAllCabang"
                                    key="packageAllCabang"
                                    name="packageAllCabang"
                                    label="All"
                                    checked={this.state.isAllSelected}
                                    onChange={(e) => this.handleSelectedBranch(e, "all")}
                                />
                                <SimpleCheckBox
                                    id="specific"
                                    key="specific"
                                    name="specific"
                                    label="Specific"
                                    checked={this.state.isSpecificSelected}
                                    onChange={(e) => this.handleSelectedBranch(e, "specific")}
                                />
                            </div>
                            {
                                (R.isNil(this.props.controls.packageSpecificCabang.value)
                                    || !this.props.controls.packageSpecificCabang.value)
                                && !R.isNil(this.props.errorListCabang)
                                && (
                                    <p className="txt-site txt-11 color-red margin-top-5px">{this.props.errorListCabang}</p>
                                )}
                        </div>

                        {this.state.isSpecificSelected && (
                            <SimpleDDL
                                id="select_options_kodeCabang"
                                name="listCabang"
                                label="Cabang Berlaku"
                                box="multiselect"
                                mandatory
                                options={this.state.dataCabang.map(item => mapToDDL(item.namaDealer, item.kodeCabang))}
                                errorMessage={this.props.errorListCabang}
                                value={this.props.controls.listCabang.value}
                                onChange={(value, {name}) =>
                                    this.props.setValue(name, value)
                                }
                            />
                        )}
                    </div>
                    <div id="grid-2">
                        <SimpleDDL
                            id="select_options_kodeVariant"
                            name="listVariant"
                            label="Kode Variant"
                            box="multiselect"
                            mandatory
                            options={this.state.dataVariant.map(item => mapToDDL(item.kodeVariant, item.kodeVariant))}
                            errorMessage={this.props.errors.listVariant}
                            value={this.props.controls.listVariant.value}
                            onChange={(value, {name}) =>
                                this.props.setValue(name, value)
                            }
                        />
                        <SimpleDate
                            backdate
                            label="Start Date"
                            date={this.props.controls.packageStartDate.value}
                            disabled={this.props.controls.packageHasGracePeriod?.value}
                            mandatory={!this.props.controls.packageHasGracePeriod?.value}
                            errorMessage={this.props.errorStartDate}
                            onChange={(value) =>
                                this.props.setValue("packageStartDate", M(value).format("DD-MM-YYYY"))
                            }
                        />
                        <SimpleDate
                            backdate
                            label="End Date"
                            date={this.props.controls.packageEndDate.value}
                            disabled={this.props.controls.packageHasGracePeriod?.value}
                            mandatory={!this.props.controls.packageHasGracePeriod?.value}
                            errorMessage={this.props.errorEndDate}
                            onChange={(value) =>
                                this.props.setValue("packageEndDate", M(value).format("DD-MM-YYYY"))
                            }
                        />
                        <div className="grid grid-2x grid-mobile-none gap-30px">
                            <FlexView vAlignContent={"center"} style={{gap: 10}}>
                                <SimpleInput
                                    id="input_text_gracePeriod"
                                    name="packageGracePeriod"
                                    label="Grace Period"
                                    box="onlyNumber"
                                    readOnly={this.props.controls.packageHasGracePeriod?.value}
                                    value={this.props.controls.packageGracePeriod.value}
                                    onChange={({target}) =>
                                        this.props.setValue(target.name, target.value)
                                    }
                                />
                                <div className="txt-15">
                                    <span>Hari</span>
                                </div>
                            </FlexView>
                            <SimpleCheckBox
                                id="noPeriod"
                                key="noPeriod"
                                name="packageHasGracePeriod"
                                label="No Period"
                                checked={this.props.controls.packageHasGracePeriod.value}
                                onChange={(e) => this.handleHasPeriod(e.target.checked)}
                            />
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

export default MasterPackageHeader;